/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ContentManagementListContentRequest = {
    categories?: Array<string>;
    types?: Array<string>;
    statuses?: Array<string>;
    name?: string;
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: ContentManagementListContentRequest.direction | null;
};

export namespace ContentManagementListContentRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

